import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '@morningstar/shared/base/base-service';
import { MailForwarding } from './mail-forwarding';

@Injectable({
  providedIn: 'root'
})
export class MailForwardingService extends ApiService<MailForwarding> {

  dataDescription = 'mail forwarding';

  constructor(protected httpClient: HttpClient,
              snackbar: MatSnackBar,
              @Inject('API_BASE_URL') baseUrl) {
    super(httpClient, baseUrl, snackbar);
  }

  getByLocation(location: string) {
    const endpoint = `dashboard/mail-forwarding/${location}`;

    return this.getList(endpoint);
  }
}
